/// <reference types="./transition_group.d.mts" />
import * as $unsafe from "../../../common_common/gleam/unsafe.mjs";
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $bool from "../../../gleam_stdlib/gleam/bool.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $pair from "../../../gleam_stdlib/gleam/pair.mjs";
import * as $lustre from "../../../lustre/lustre.mjs";
import * as $attribute from "../../../lustre/lustre/attribute.mjs";
import * as $component from "../../../lustre/lustre/component.mjs";
import * as $eff from "../../../lustre/lustre/effect.mjs";
import * as $element from "../../../lustre/lustre/element.mjs";
import * as $css from "../../../sketch/sketch/css.mjs";
import * as $sl from "../../../sketch_lustre/sketch/lustre.mjs";
import * as $el from "../../../sketch_lustre/sketch/lustre/element.mjs";
import * as $h from "../../../sketch_lustre/sketch/lustre/element/html.mjs";
import * as $events from "../../ds/internals/components/events.mjs";
import * as $u from "../../ds/internals/unsafe.mjs";
import { Ok, Error, toList, prepend as listPrepend, CustomType as $CustomType } from "../../gleam.mjs";
import * as $window from "../../web/browser/window.mjs";
import * as $global from "../../web/javascript/global.mjs";

class Started extends $CustomType {}

class InProgress extends $CustomType {}

class Ended extends $CustomType {}

class Model extends $CustomType {
  constructor(children, duration, enter_state, enter, entered, entering, exit_state, exit, exited, exiting, timer_id, timestamp) {
    super();
    this.children = children;
    this.duration = duration;
    this.enter_state = enter_state;
    this.enter = enter;
    this.entered = entered;
    this.entering = entering;
    this.exit_state = exit_state;
    this.exit = exit;
    this.exited = exited;
    this.exiting = exiting;
    this.timer_id = timer_id;
    this.timestamp = timestamp;
  }
}

class ElementFinishedMounting extends $CustomType {}

class ElementStartedEnter extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class ElementFinishedEnter extends $CustomType {}

class ElementReceivedMsg extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class ElementUpdatedDestroyed extends $CustomType {}

class ElementStartedExit extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class ElementFinishedExit extends $CustomType {}

class UserUpdatedChildren extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class UserUpdatedDestroy extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class UserUpdatedDuration extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class UserUpdatedEnter extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class UserUpdatedEntered extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class UserUpdatedEntering extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class UserUpdatedExit extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class UserUpdatedExited extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class UserUpdatedExiting extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export function destroy(destroy) {
  return $attribute.attribute(
    "destroy",
    (() => {
      if (destroy) {
        return "true";
      } else {
        return "false";
      }
    })(),
  );
}

export function duration(duration) {
  return $attribute.property("duration", $json.int(duration));
}

export function enter(class$) {
  return $attribute.property("enter", $unsafe.coerce(class$));
}

export function entered(class$) {
  return $attribute.property("entered", $unsafe.coerce(class$));
}

export function entering(class$) {
  return $attribute.property("entering", $unsafe.coerce(class$));
}

export function exit(class$) {
  return $attribute.property("exit", $unsafe.coerce(class$));
}

export function exited(class$) {
  return $attribute.property("exited", $unsafe.coerce(class$));
}

export function exiting(class$) {
  return $attribute.property("exiting", $unsafe.coerce(class$));
}

function init(_) {
  let duration$1 = 1000;
  let _pipe = new Model(
    toList([]),
    duration$1,
    new Started(),
    $css.class$(toList([])),
    $css.class$(toList([])),
    $css.class$(toList([])),
    new None(),
    $css.class$(toList([])),
    $css.class$(toList([])),
    $css.class$(toList([])),
    new None(),
    $u.timestamp(),
  );
  return $pair.new$(
    _pipe,
    $eff.from(
      (dispatch) => {
        $window.request_animation_frame(
          (_) => { return dispatch(new ElementFinishedMounting()); },
        );
        return undefined;
      },
    ),
  );
}

function start_enter_progress(model) {
  return [
    (() => {
      let _record = model;
      return new Model(
        _record.children,
        _record.duration,
        new InProgress(),
        _record.enter,
        _record.entered,
        _record.entering,
        _record.exit_state,
        _record.exit,
        _record.exited,
        _record.exiting,
        _record.timer_id,
        $u.timestamp(),
      );
    })(),
    $eff.from(
      (dispatch) => {
        let _pipe = $global.set_timeout(
          model.duration,
          () => { return dispatch(new ElementFinishedEnter()); },
        );
        let _pipe$1 = new ElementStartedEnter(_pipe);
        return dispatch(_pipe$1);
      },
    ),
  ];
}

function store_timeout(model, timer_id) {
  let _block;
  let _record = model;
  _block = new Model(
    _record.children,
    _record.duration,
    _record.enter_state,
    _record.enter,
    _record.entered,
    _record.entering,
    _record.exit_state,
    _record.exit,
    _record.exited,
    _record.exiting,
    new Some(timer_id),
    _record.timestamp,
  );
  let _pipe = _block;
  return $pair.new$(_pipe, $eff.none());
}

function done_enter(model) {
  let _block;
  let _record = model;
  _block = new Model(
    _record.children,
    _record.duration,
    new Ended(),
    _record.enter,
    _record.entered,
    _record.entering,
    _record.exit_state,
    _record.exit,
    _record.exited,
    _record.exiting,
    new None(),
    _record.timestamp,
  );
  let _pipe = _block;
  return $pair.new$(_pipe, $eff.none());
}

function update_duration(model, duration) {
  let elapsed_time = $u.timestamp() - model.timestamp;
  let duration$1 = duration - elapsed_time;
  return [
    (() => {
      let _record = model;
      return new Model(
        _record.children,
        duration$1,
        _record.enter_state,
        _record.enter,
        _record.entered,
        _record.entering,
        _record.exit_state,
        _record.exit,
        _record.exited,
        _record.exiting,
        _record.timer_id,
        _record.timestamp,
      );
    })(),
    (() => {
      let $ = model.timer_id;
      if ($ instanceof $option.Some) {
        let timer_id = $[0];
        return $eff.from(
          (dispatch) => {
            $global.clear_timeout(timer_id);
            let _pipe = $global.set_timeout(
              duration$1,
              () => { return dispatch(new ElementFinishedEnter()); },
            );
            let _pipe$1 = new ElementStartedEnter(_pipe);
            return dispatch(_pipe$1);
          },
        );
      } else {
        return $eff.none();
      }
    })(),
  ];
}

function start_destroying(model, destroying) {
  return $bool.guard(
    !destroying,
    [model, $eff.none()],
    () => {
      return [
        (() => {
          let _record = model;
          return new Model(
            _record.children,
            _record.duration,
            _record.enter_state,
            _record.enter,
            _record.entered,
            _record.entering,
            new Some(new Started()),
            _record.exit,
            _record.exited,
            _record.exiting,
            _record.timer_id,
            _record.timestamp,
          );
        })(),
        $eff.from(
          (dispatch) => {
            $window.request_animation_frame(
              (_) => { return dispatch(new ElementUpdatedDestroyed()); },
            );
            return undefined;
          },
        ),
      ];
    },
  );
}

function start_exit_progress(model) {
  return [
    (() => {
      let _record = model;
      return new Model(
        _record.children,
        _record.duration,
        _record.enter_state,
        _record.enter,
        _record.entered,
        _record.entering,
        new Some(new InProgress()),
        _record.exit,
        _record.exited,
        _record.exiting,
        _record.timer_id,
        $u.timestamp(),
      );
    })(),
    $eff.from(
      (dispatch) => {
        let _pipe = $global.set_timeout(
          model.duration,
          () => { return dispatch(new ElementFinishedExit()); },
        );
        let _pipe$1 = new ElementStartedExit(_pipe);
        dispatch(_pipe$1)
        return undefined;
      },
    ),
  ];
}

function done_exit(model) {
  return [
    (() => {
      let _record = model;
      return new Model(
        _record.children,
        _record.duration,
        _record.enter_state,
        _record.enter,
        _record.entered,
        _record.entering,
        new Some(new Ended()),
        _record.exit,
        _record.exited,
        _record.exiting,
        _record.timer_id,
        _record.timestamp,
      );
    })(),
    $eff.none(),
  ];
}

function update(model, msg) {
  if (msg instanceof ElementFinishedMounting) {
    return start_enter_progress(model);
  } else if (msg instanceof ElementStartedEnter) {
    let timer_id = msg[0];
    return store_timeout(model, timer_id);
  } else if (msg instanceof ElementFinishedEnter) {
    return done_enter(model);
  } else if (msg instanceof ElementReceivedMsg) {
    let msg$1 = msg[0];
    return [model, $events.traverse(msg$1)];
  } else if (msg instanceof ElementUpdatedDestroyed) {
    return start_exit_progress(model);
  } else if (msg instanceof ElementStartedExit) {
    let timer_id = msg[0];
    return store_timeout(model, timer_id);
  } else if (msg instanceof ElementFinishedExit) {
    return done_exit(model);
  } else if (msg instanceof UserUpdatedChildren) {
    let children = msg[0];
    return [
      (() => {
        let _record = model;
        return new Model(
          children,
          _record.duration,
          _record.enter_state,
          _record.enter,
          _record.entered,
          _record.entering,
          _record.exit_state,
          _record.exit,
          _record.exited,
          _record.exiting,
          _record.timer_id,
          _record.timestamp,
        );
      })(),
      $eff.none(),
    ];
  } else if (msg instanceof UserUpdatedDestroy) {
    let destroying = msg[0];
    return start_destroying(model, destroying);
  } else if (msg instanceof UserUpdatedDuration) {
    let duration$1 = msg[0];
    return update_duration(model, duration$1);
  } else if (msg instanceof UserUpdatedEnter) {
    let enter$1 = msg[0];
    return [
      (() => {
        let _record = model;
        return new Model(
          _record.children,
          _record.duration,
          _record.enter_state,
          enter$1,
          _record.entered,
          _record.entering,
          _record.exit_state,
          _record.exit,
          _record.exited,
          _record.exiting,
          _record.timer_id,
          _record.timestamp,
        );
      })(),
      $eff.none(),
    ];
  } else if (msg instanceof UserUpdatedEntered) {
    let entered$1 = msg[0];
    return [
      (() => {
        let _record = model;
        return new Model(
          _record.children,
          _record.duration,
          _record.enter_state,
          _record.enter,
          entered$1,
          _record.entering,
          _record.exit_state,
          _record.exit,
          _record.exited,
          _record.exiting,
          _record.timer_id,
          _record.timestamp,
        );
      })(),
      $eff.none(),
    ];
  } else if (msg instanceof UserUpdatedEntering) {
    let entering$1 = msg[0];
    return [
      (() => {
        let _record = model;
        return new Model(
          _record.children,
          _record.duration,
          _record.enter_state,
          _record.enter,
          _record.entered,
          entering$1,
          _record.exit_state,
          _record.exit,
          _record.exited,
          _record.exiting,
          _record.timer_id,
          _record.timestamp,
        );
      })(),
      $eff.none(),
    ];
  } else if (msg instanceof UserUpdatedExit) {
    let exit$1 = msg[0];
    return [
      (() => {
        let _record = model;
        return new Model(
          _record.children,
          _record.duration,
          _record.enter_state,
          _record.enter,
          _record.entered,
          _record.entering,
          _record.exit_state,
          exit$1,
          _record.exited,
          _record.exiting,
          _record.timer_id,
          _record.timestamp,
        );
      })(),
      $eff.none(),
    ];
  } else if (msg instanceof UserUpdatedExited) {
    let exited$1 = msg[0];
    return [
      (() => {
        let _record = model;
        return new Model(
          _record.children,
          _record.duration,
          _record.enter_state,
          _record.enter,
          _record.entered,
          _record.entering,
          _record.exit_state,
          _record.exit,
          exited$1,
          _record.exiting,
          _record.timer_id,
          _record.timestamp,
        );
      })(),
      $eff.none(),
    ];
  } else {
    let exiting$1 = msg[0];
    return [
      (() => {
        let _record = model;
        return new Model(
          _record.children,
          _record.duration,
          _record.enter_state,
          _record.enter,
          _record.entered,
          _record.entering,
          _record.exit_state,
          _record.exit,
          _record.exited,
          exiting$1,
          _record.timer_id,
          _record.timestamp,
        );
      })(),
      $eff.none(),
    ];
  }
}

function join(class1, class2) {
  return $css.class$(toList([$css.compose(class1), $css.compose(class2)]));
}

function select_enter_classes(model) {
  let $ = model.enter_state;
  if ($ instanceof Started) {
    return model.entering;
  } else if ($ instanceof InProgress) {
    return join(model.entering, model.enter);
  } else {
    return model.entered;
  }
}

function select_exit_classes(model) {
  return $option.map(
    model.exit_state,
    (exit_state) => {
      if (exit_state instanceof Started) {
        return model.exiting;
      } else if (exit_state instanceof InProgress) {
        return join(model.exiting, model.exit);
      } else {
        return model.exited;
      }
    },
  );
}

function select_classes(model) {
  let enter$1 = select_enter_classes(model);
  let exit$1 = select_exit_classes(model);
  if (exit$1 instanceof Some) {
    let exit$2 = exit$1[0];
    return $css.class$(toList([$css.compose(enter$1), $css.compose(exit$2)]));
  } else {
    return enter$1;
  }
}

function view(model, stylesheet) {
  return $sl.render(
    stylesheet,
    toList([$sl.node()]),
    () => {
      let class$ = select_classes(model);
      let class$1 = $el.class_name(class$);
      let _pipe = $h.div_(toList([$attribute.class$(class$1)]), model.children);
      return $element.map(
        _pipe,
        (var0) => { return new ElementReceivedMsg(var0); },
      );
    },
  );
}

const tag_name = "transition-group";

export function transition_group(attributes, children) {
  let children$1 = $attribute.property("children", $unsafe.coerce(children));
  let passthrough = $events.passthrough();
  return $element.element(
    tag_name,
    listPrepend(children$1, listPrepend(passthrough, attributes)),
    toList([]),
  );
}

export function register(stylesheet) {
  let _pipe = $lustre.component(
    init,
    update,
    (_capture) => { return view(_capture, stylesheet); },
    toList([
      $component.adopt_styles(true),
      $component.on_property_change(
        "children",
        (() => {
          let _pipe = $decode.dynamic;
          let _pipe$1 = $decode.map(_pipe, $unsafe.coerce);
          return $decode.map(
            _pipe$1,
            (var0) => { return new UserUpdatedChildren(var0); },
          );
        })(),
      ),
      $component.on_attribute_change(
        "destroy",
        (content) => {
          if (content === "true") {
            return new Ok(new UserUpdatedDestroy(true));
          } else if (content === "True") {
            return new Ok(new UserUpdatedDestroy(true));
          } else if (content === "false") {
            return new Ok(new UserUpdatedDestroy(false));
          } else if (content === "False") {
            return new Ok(new UserUpdatedDestroy(false));
          } else {
            return new Error(undefined);
          }
        },
      ),
      $component.on_property_change(
        "duration",
        (() => {
          let _pipe = $decode.int;
          return $decode.map(
            _pipe,
            (var0) => { return new UserUpdatedDuration(var0); },
          );
        })(),
      ),
      $component.on_property_change(
        "enter",
        (() => {
          let _pipe = $decode.dynamic;
          let _pipe$1 = $decode.map(_pipe, $unsafe.coerce);
          return $decode.map(
            _pipe$1,
            (var0) => { return new UserUpdatedEnter(var0); },
          );
        })(),
      ),
      $component.on_property_change(
        "entered",
        (() => {
          let _pipe = $decode.dynamic;
          let _pipe$1 = $decode.map(_pipe, $unsafe.coerce);
          return $decode.map(
            _pipe$1,
            (var0) => { return new UserUpdatedEntered(var0); },
          );
        })(),
      ),
      $component.on_property_change(
        "entering",
        (() => {
          let _pipe = $decode.dynamic;
          let _pipe$1 = $decode.map(_pipe, $unsafe.coerce);
          return $decode.map(
            _pipe$1,
            (var0) => { return new UserUpdatedEntering(var0); },
          );
        })(),
      ),
      $component.on_property_change(
        "exit",
        (() => {
          let _pipe = $decode.dynamic;
          let _pipe$1 = $decode.map(_pipe, $unsafe.coerce);
          return $decode.map(
            _pipe$1,
            (var0) => { return new UserUpdatedExit(var0); },
          );
        })(),
      ),
      $component.on_property_change(
        "exited",
        (() => {
          let _pipe = $decode.dynamic;
          let _pipe$1 = $decode.map(_pipe, $unsafe.coerce);
          return $decode.map(
            _pipe$1,
            (var0) => { return new UserUpdatedExited(var0); },
          );
        })(),
      ),
      $component.on_property_change(
        "exiting",
        (() => {
          let _pipe = $decode.dynamic;
          let _pipe$1 = $decode.map(_pipe, $unsafe.coerce);
          return $decode.map(
            _pipe$1,
            (var0) => { return new UserUpdatedExiting(var0); },
          );
        })(),
      ),
    ]),
  );
  return $lustre.register(_pipe, tag_name);
}
